import type { ClientPropertyVehicleDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import type { PropertyOptionalParam } from "web_myplann/Portfolio/Hooks/useGetPropertyOptionalParams";

const PageResources = Resources.PortfolioDetail;

export const CAR_SPECIAL_EQUIPMENT: PropertyOptionalParam<ClientPropertyVehicleDetailResponseDTO>[] =
	[
		{
			key: "carSpecialEquipment44",
			label: PageResources.Property.CarSpecialEquipment44,
		},
		{
			key: "carSpecialEquipmentAudiovisualSystem",
			label: PageResources.Property.CarSpecialEquipmentAudiovisualSystem,
		},
		{
			key: "carSpecialEquipmentLeatherUpholstery",
			label: PageResources.Property.CarSpecialEquipmentLeatherUpholstery,
		},
		{
			key: "carSpecialEquipmentPanoramicRoof",
			label: PageResources.Property.CarSpecialEquipmentPanoramicRoof,
		},
		{
			key: "carSpecialEquipmentParkingAssistant",
			label: PageResources.Property.CarSpecialEquipmentParkingAssistant,
		},
	];
